type GlobalWindow = Window & typeof globalThis;

type WindowWithLocale = GlobalWindow & { locale: string };

export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const LOCALE = (window as WindowWithLocale).locale;
export const EN_US = 'en_US';
export const DEFAULT_SITE_NAME = 'Entertainment Partners';
